import { Component, Input, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ConsultingDashboardService } from 'src/app/api/consulting-dashboard.service';
import { CustomerLogForStaff } from 'src/app/api/types/partner';
import { DateTime } from 'luxon';
import { of } from 'rxjs';
import { Contact } from 'src/app/api/types/contacts';
import { TripDetail } from 'src/app/api/commonInterfaces';
import { EditScheduledActivityComponentInputs } from 'src/app/component-modules/notes/edit-scheduled-activity/edit-scheduled-activity.component';
import { DataPadService } from 'src/app/ui/data-pad/data-pad.service';
import { IconService } from 'src/app/ui/icon.service';
import { UiModule } from 'src/app/ui/ui.module';
import { LocalAuthService } from 'src/app/auth/local-auth.service';
import { Timeframe } from 'src/app/api/types/recruiting';
import { NotesModule } from 'src/app/component-modules/notes/notes.module';

@Component({
  selector: 'app-consulting-scheduled-activities',
  templateUrl: './consulting-scheduled-activities.component.html',
  styleUrls: ['./consulting-scheduled-activities.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, UiModule, NotesModule]
})
export class ConsultingScheduledActivitiesComponent implements OnInit {
  activities = signal<CustomerLogForStaff[]>([]);
  loading = true;
  error: string | null = null;
  showAddActivityButton = false;

  @Input() staffId: number = 0;
  @Input() timeframe: Timeframe = 'week';
  @Input() maxHeight: number = 0;

  constructor(
    private consultingDashboardService: ConsultingDashboardService,
    private dataPadService: DataPadService,
    public icons: IconService,
    private auth: LocalAuthService
  ) {}

  ngOnInit() {
    if (!this.staffId) return;
    this.showAddActivityButton = this.auth.currentUser?.newstaffId === this.staffId;
    this.loadActivities(this.staffId);
  }

  private loadActivities(staffId: number) {
    this.loading = true;
    this.consultingDashboardService.getThisWeekConsultingActivitiesForStaff(staffId).subscribe({
      next: (data) => {
        this.activities.set(data);
        this.loading = false;
      },
      error: (err) => {
        this.error = 'Failed to load activities';
        this.loading = false;
        console.error('Error loading activities:', err);
      }
    });
  }

  setTitle() {
    switch (this.timeframe) {
      case "day": return "Today's Consulting Activities";
      case "week": return "This Week's Consulting Activities";
      case "month": return "This Month's Consulting Activities";
      case "year": return "This Year's Consulting Activities";
      case "all": return "All Consulting Activities";
    }
  }

  setNoActivitiesMessage() {
    switch (this.timeframe) {
      case "day": return "No activities scheduled for today";
      case "week": return "No activities scheduled for this week";
      case "month": return "No activities scheduled for this month";
      case "year": return "No activities scheduled for this year";
      case "all": return "No activities scheduled";
    }
  }

  formatDatetime(date: Date): string {
    return DateTime.fromJSDate(new Date(date)).toFormat('MM/dd/yyyy hh:mm a');
  }

  addActivity() {
    this.dataPadService.showPanel<EditScheduledActivityComponentInputs>(
      { 
        panelName: "editScheduledActivity", 
        inputData: { 
          tripDetails: [], 
          custId: 0, 
          contacts: [], 
          inputObservables: { 
            contacts: of<Contact[]>([]), 
            tripDetails: of<TripDetail[]>([]) 
          } 
        } 
      }
    )
  }
} 